import { Configs } from "../gameLoader/Configs";
import { loadText } from "../gameLoader/utils";

let revision: Promise<string> | null = null;

/** Cache buster for the REVISION file itself, and the fallback when it is unavailable. */
const getTimeRevision = (): string => {
    const now = new Date();
    now.setSeconds(0, 0);

    return String(now.getTime());
};

const loadRevision = async (): Promise<string> => {
    const timeRevision = getTimeRevision();

    try {
        return await loadText(`${new Configs().getPrefixXmlFolder()}/REVISION?_=${timeRevision}`);
    } catch (error: any) {
        console.warn(`[GM] ${error.message}`);
        return timeRevision;
    }
};

/**
 * Deploy revision shared by every static config request: *.xml and env/env.json.
 * Resolved once per page load, so every consumer gets the same value.
 */
export const getRevision = (): Promise<string> => {
    if (!revision) {
        revision = loadRevision();
    }

    return revision;
};
